export const canvasWidth = 1920;
export const canvasHeight = 920;

export {};
